(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Custom-sub-col-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialiseSunColCarousel(root) {
    if (!root || root.dataset.sunColCarouselInitialised === 'true') return;

    var rail = root.querySelector('[data-sun-col-carousel-rail]');
    var wrap = root.querySelector('[data-sun-col-carousel-wrap]');
    var prev = root.querySelector('[data-sun-col-carousel-prev]');
    var next = root.querySelector('[data-sun-col-carousel-next]');

    if (!rail || !wrap || !prev || !next) return;

    function setFadeColour() {
      var element = root;
      var fadeColour = '';

      while (element) {
        var backgroundColour = window.getComputedStyle(element).backgroundColor;
        var normalisedColour = backgroundColour.replace(/\s+/g, '').toLowerCase();

        if (
          normalisedColour &&
          normalisedColour !== 'transparent' &&
          normalisedColour !== 'rgba(0,0,0,0)'
        ) {
          fadeColour = backgroundColour;
          break;
        }

        element = element.parentElement;
      }

      if (fadeColour) {
        root.style.setProperty('--sun-col-fade-color', fadeColour);
      }
    }

    function updateControls() {
      var canScroll = rail.scrollWidth > rail.clientWidth + 5;
      var hasStarted = rail.scrollLeft > 5;
      var isAtEnd = !canScroll || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 5;

      wrap.classList.toggle('has-started', hasStarted);
      wrap.classList.toggle('is-end', isAtEnd);
    }

    function scrollOneCard(direction) {
      var card = rail.querySelector('.sun-col-carousel__card');
      if (!card) return;

      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () {
      scrollOneCard(-1);
    });

    next.addEventListener('click', function () {
      scrollOneCard(1);
    });

    rail.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', function () {
      setFadeColour();
      updateControls();
    });
    setFadeColour();
    updateControls();

    root.dataset.sunColCarouselInitialised = 'true';
  }

  function initialiseAllSunColCarousels(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-sun-col-carousel]')) {
      initialiseSunColCarousel(context);
    }

    context.querySelectorAll('[data-sun-col-carousel]').forEach(initialiseSunColCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAllSunColCarousels(document);
    });
  } else {
    initialiseAllSunColCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initialiseAllSunColCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hp-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCollectionCarousel(root) {
    if (!root || root.dataset.sdCollectionsInitialised === 'true') return;

    var rail = root.querySelector('[data-sd-collections-rail]');
    var prev = root.querySelector('[data-sd-collections-prev]');
    var next = root.querySelector('[data-sd-collections-next]');

    if (!rail || !prev || !next) return;

    function updateFade() {
      var wrap = rail.closest('.sd-collections__rail-wrap');
      if (!wrap) return;

      var hasStarted = rail.scrollLeft > 5;
      var isAtEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 5;

      wrap.classList.toggle('has-started', hasStarted);
      wrap.classList.toggle('is-end', isAtEnd);
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -360, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      rail.scrollBy({ left: 360, behavior: 'smooth' });
    });

    rail.addEventListener('scroll', updateFade);
    window.addEventListener('resize', updateFade);

    updateFade();

    root.dataset.sdCollectionsInitialised = 'true';
  }

  function initAllCollectionCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll('.sd-collections').forEach(initCollectionCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCollectionCarousels(document);
    });
  } else {
    initAllCollectionCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAllCollectionCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creative-directors-favourites"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCreativeFavourites(root) {
    if (!root || root.dataset.sdCdfInitialised === 'true') return;

    const panels = Array.from(root.querySelectorAll('[data-sd-cdf-panel]'));
    const cards = Array.from(root.querySelectorAll('[data-sd-cdf-card]'));
    const railWrap = root.querySelector('.sd-cdf__rail-wrap');
    const rail = root.querySelector('[data-sd-cdf-rail]');
    const prev = root.querySelector('[data-sd-cdf-prev]');
    const next = root.querySelector('[data-sd-cdf-next]');

    if (!panels.length || !cards.length) return;

    function setActive(index) {
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });

      cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === index);
        card.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    function updateArrowVisibility() {
      if (!rail || !railWrap) return;

      var hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
      railWrap.classList.toggle('has-no-overflow', !hasOverflow);
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        setActive(index);
      });
    });

    if (rail && prev && next) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -320, behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        rail.scrollBy({ left: 320, behavior: 'smooth' });
      });
    }

    window.addEventListener('resize', updateArrowVisibility);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateArrowVisibility);
    }

    setActive(0);
    updateArrowVisibility();

    window.setTimeout(updateArrowVisibility, 300);

    root.dataset.sdCdfInitialised = 'true';
  }

  function initAllCreativeFavourites(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-sd-cdf]').forEach(initCreativeFavourites);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCreativeFavourites(document);
    });
  } else {
    initAllCreativeFavourites(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAllCreativeFavourites(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-carousel-frosted"] && !Shopify.designMode) return;
  try {
    
(function () {
  const AUTOPLAY_MS = 7000;
  const DRAG_THRESHOLD = 50;
  const VELOCITY_THRESHOLD = 0.42;
  const CLICK_SUPPRESS_THRESHOLD = 8;
  const MOMENTUM_MULTIPLIER = 140;
  const SLIDE_TRANSITION = 'transform 0.72s cubic-bezier(0.22, 1, 0.36, 1)';
  const MOBILE_QUERY = '(max-width: 768px)';
  const COMPACT_QUERY =
    '(min-width: 769px) and (max-width: 1100px)';
  const EDITORIAL_TEXT_RGB = [40, 40, 40];
  const EDITORIAL_MIN_CONTRAST = 4.5;

  function parseHexColor(value) {
    const hex = String(value || '')
      .trim()
      .replace('#', '');

    if (!/^[0-9a-f]{3}([0-9a-f]{3})?$/i.test(hex)) {
      return null;
    }

    const expanded =
      hex.length === 3
        ? hex
            .split('')
            .map(function (character) {
              return character + character;
            })
            .join('')
        : hex;

    return [
      parseInt(expanded.slice(0, 2), 16),
      parseInt(expanded.slice(2, 4), 16),
      parseInt(expanded.slice(4, 6), 16)
    ];
  }

  function relativeLuminance(rgb) {
    const channels = rgb.map(function (value) {
      const channel = value / 255;

      return channel <= 0.03928
        ? channel / 12.92
        : Math.pow((channel + 0.055) / 1.055, 2.4);
    });

    return (
      channels[0] * 0.2126 +
      channels[1] * 0.7152 +
      channels[2] * 0.0722
    );
  }

  function contrastRatio(firstRgb, secondRgb) {
    const first = relativeLuminance(firstRgb);
    const second = relativeLuminance(secondRgb);
    const lighter = Math.max(first, second);
    const darker = Math.min(first, second);

    return (lighter + 0.05) / (darker + 0.05);
  }

  function mixWithWhite(rgb, amount) {
    return rgb.map(function (value) {
      return Math.round(value + (255 - value) * amount);
    });
  }

  function rgbToHex(rgb) {
    return (
      '#' +
      rgb
        .map(function (value) {
          return value.toString(16).padStart(2, '0');
        })
        .join('')
    );
  }

  function getSafeEditorialColor(color) {
    const rgb = parseHexColor(color);

    if (
      !rgb ||
      contrastRatio(rgb, EDITORIAL_TEXT_RGB) >=
        EDITORIAL_MIN_CONTRAST
    ) {
      return color;
    }

    let low = 0;
    let high = 1;

    for (
      let iteration = 0;
      iteration < 18;
      iteration += 1
    ) {
      const midpoint = (low + high) / 2;
      const candidate = mixWithWhite(rgb, midpoint);

      if (
        contrastRatio(
          candidate,
          EDITORIAL_TEXT_RGB
        ) >= EDITORIAL_MIN_CONTRAST
      ) {
        high = midpoint;
      } else {
        low = midpoint;
      }
    }

    return rgbToHex(mixWithWhite(rgb, high));
  }

  function applyEditorialContrast(root) {
    root
      .querySelectorAll('[data-editorial-bg]')
      .forEach(function (slide) {
        const selectedColor =
          slide.dataset.editorialBg;

        const useSafeguard =
          slide.dataset.editorialAutoContrast ===
          'true';

        slide.style.setProperty(
          '--editorial-bg',
          useSafeguard
            ? getSafeEditorialColor(selectedColor)
            : selectedColor
        );
      });
  }

  function initGlassCarousel(root) {
    if (!root || root.dataset.carouselGlassInitialised === 'true') return;

    const viewport = root.querySelector('.custom-carousel-glass__viewport');
    const track = root.querySelector('.custom-carousel-glass');
    const slides = Array.from(
      root.querySelectorAll('.custom-carousel-glass__slide')
    );
    const navButtons = Array.from(
      root.querySelectorAll('.custom-carousel-glass__nav button')
    );
    const hotspots = Array.from(
      root.querySelectorAll('.custom-carousel-glass__hotspot')
    );
    const images = Array.from(
      root.querySelectorAll('.custom-carousel-glass__image')
    );
    const editorialSlides = Array.from(
      root.querySelectorAll(
        '.custom-carousel-glass__slide--editorial'
      )
    );

    applyEditorialContrast(root);

    const mobileMediaQuery = window.matchMedia(MOBILE_QUERY);
    const compactMediaQuery =
      window.matchMedia(COMPACT_QUERY);
    const hoverMediaQuery = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

    if (
      !viewport ||
      !track ||
      slides.length === 0
    ) {
      return;
    }

    let currentIndex = 0;
    let intervalId = null;
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let startTime = 0;
    let suppressClick = false;
    let suppressClickTimeoutId = null;
    let dismissedHotspotOnDragStart = false;
    let deferredMediaHandle = null;
    let deferredMediaUsesIdleCallback = false;
    let deferredMediaLoadHandler = null;
    let isPointerHovering =
      hoverMediaQuery.matches &&
      root.matches(':hover');

    function loadSlideMedia(slide, priority) {
      if (!slide) return;

      slide
        .querySelectorAll('source[data-carousel-srcset]')
        .forEach(function (source) {
          source.srcset = source.dataset.carouselSrcset;
          source.removeAttribute('data-carousel-srcset');
        });

      slide
        .querySelectorAll('img[data-carousel-src]')
        .forEach(function (image) {
          const requestedPriority =
            image.dataset.carouselPriority || priority;

          image.loading = 'eager';
          image.decoding = 'async';
          image.fetchPriority =
            requestedPriority === 'high' ? 'high' : 'low';

          image.removeAttribute('data-carousel-priority');

          if (image.dataset.carouselSrcset) {
            image.srcset = image.dataset.carouselSrcset;
            image.removeAttribute('data-carousel-srcset');
          }

          image.src = image.dataset.carouselSrc;
          image.removeAttribute('data-carousel-src');
        });
    }

    function cancelDeferredMediaLoad() {
      if (deferredMediaLoadHandler) {
        window.removeEventListener(
          'load',
          deferredMediaLoadHandler
        );
        deferredMediaLoadHandler = null;
      }

      if (deferredMediaHandle === null) return;

      if (
        deferredMediaUsesIdleCallback &&
        'cancelIdleCallback' in window
      ) {
        window.cancelIdleCallback(deferredMediaHandle);
      } else {
        window.clearTimeout(deferredMediaHandle);
      }

      deferredMediaHandle = null;
      deferredMediaUsesIdleCallback = false;
    }

    function scheduleNextSlideMedia(index) {
      cancelDeferredMediaLoad();

      if (slides.length < 2) return;

      const nextIndex =
        (index + 1) % slides.length;

      const loadNextSlide = function () {
        deferredMediaHandle = null;
        deferredMediaUsesIdleCallback = false;
        loadSlideMedia(slides[nextIndex], 'low');
      };

      const queueNextSlide = function () {
        if ('requestIdleCallback' in window) {
          deferredMediaUsesIdleCallback = true;
          deferredMediaHandle =
            window.requestIdleCallback(
              loadNextSlide,
              { timeout: 1500 }
            );
        } else {
          deferredMediaHandle =
            window.setTimeout(loadNextSlide, 900);
        }
      };

      if (document.readyState !== 'complete') {
        deferredMediaLoadHandler = function () {
          deferredMediaLoadHandler = null;
          queueNextSlide();
        };

        window.addEventListener(
          'load',
          deferredMediaLoadHandler,
          { once: true }
        );
      } else {
        queueNextSlide();
      }
    }

    function syncMobileTextHeights() {
      root.style.removeProperty(
        '--custom-carousel-glass-mobile-text-height'
      );

      if (!mobileMediaQuery.matches) return;

      let maxTextHeight = 0;

      slides.forEach(function (slide) {
        const text = slide.querySelector(
          '.custom-carousel-glass__text, ' +
          '.custom-carousel-glass__editorial-copy'
        );

        if (text) {
          maxTextHeight = Math.max(
            maxTextHeight,
            text.scrollHeight
          );
        }
      });

      if (maxTextHeight > 0) {
        root.style.setProperty(
          '--custom-carousel-glass-mobile-text-height',
          `${Math.ceil(maxTextHeight)}px`
        );
      }
    }

    function getContentRect(element) {
      if (!element || !element.textContent.trim()) {
        return null;
      }

      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT
      );
      const rects = [];
      let textNode = walker.nextNode();

      while (textNode) {
        if (textNode.nodeValue.trim()) {
          const range = document.createRange();
          range.selectNodeContents(textNode);

          Array.from(range.getClientRects()).forEach(
            function (rect) {
              if (rect.width > 0 && rect.height > 0) {
                rects.push(rect);
              }
            }
          );

          if (typeof range.detach === 'function') {
            range.detach();
          }
        }

        textNode = walker.nextNode();
      }

      if (rects.length === 0) return null;

      const left = Math.min.apply(
        null,
        rects.map(function (rect) {
          return rect.left;
        })
      );
      const right = Math.max.apply(
        null,
        rects.map(function (rect) {
          return rect.right;
        })
      );
      const top = Math.min.apply(
        null,
        rects.map(function (rect) {
          return rect.top;
        })
      );
      const bottom = Math.max.apply(
        null,
        rects.map(function (rect) {
          return rect.bottom;
        })
      );

      return {
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        width: right - left,
        height: bottom - top
      };
    }

    function syncEditorialVerticalFit() {
      editorialSlides.forEach(function (slide) {
        slide.classList.remove(
          'is-vertically-compact'
        );

        if (mobileMediaQuery.matches) return;

        const overline = slide.querySelector(
          '.custom-carousel-glass__editorial-overline'
        );
        const firstTitleLine = slide.querySelector(
          '.custom-carousel-glass__editorial-title-prefix, ' +
          '.custom-carousel-glass__editorial-title-main'
        );
        const body = slide.querySelector(
          '.custom-carousel-glass__editorial-body'
        );
        const lastBodyElement =
          slide.querySelector(
            '.custom-carousel-glass__button'
          ) ||
          slide.querySelector(
            '.custom-carousel-glass__description'
          ) ||
          slide.querySelector(
            '.custom-carousel-glass__editorial-heading'
          );
        const folio = slide.querySelector(
          '.custom-carousel-glass__editorial-folio'
        );

        const overlineRect = overline
          ? overline.getBoundingClientRect()
          : null;
        const firstTitleRect = getContentRect(
          firstTitleLine
        );
        const lastBodyRect = lastBodyElement
          ? lastBodyElement.getBoundingClientRect()
          : null;
        const folioIsVisible =
          folio &&
          window.getComputedStyle(folio).display !==
            'none';
        const folioRect = folioIsVisible
          ? getContentRect(folio)
          : null;

        const topIsCrowded = Boolean(
          overlineRect &&
          firstTitleRect &&
          firstTitleRect.top - overlineRect.bottom < 18
        );
        const bottomIsCrowded = Boolean(
          lastBodyRect &&
          folioRect &&
          folioRect.top - lastBodyRect.bottom < 18
        );
        const bodyIsOverflowing = Boolean(
          body &&
          body.scrollHeight > body.clientHeight + 2
        );

        slide.classList.toggle(
          'is-vertically-compact',
          topIsCrowded ||
            bottomIsCrowded ||
            bodyIsOverflowing
        );
      });
    }

    function syncEditorialMediaOverlap() {
      editorialSlides.forEach(function (slide) {
        slide.style.removeProperty(
          '--editorial-safe-copy-width'
        );

        if (mobileMediaQuery.matches) {
          slide.style.removeProperty(
            '--editorial-media-left'
          );
          slide.style.removeProperty(
            '--editorial-space-above-main-responsive'
          );
          slide.style.removeProperty(
            '--editorial-space-below-main-responsive'
          );
          return;
        }

        const canvas = slide.querySelector(
          '.custom-carousel-glass__editorial'
        );
        const title = slide.querySelector(
          '.custom-carousel-glass__editorial-title-main'
        );
        const media = slide.querySelector(
          '.custom-carousel-glass__editorial-media'
        );
        const titleRect = getContentRect(title);

        if (!canvas || !media || !titleRect) return;

        const canvasRect =
          canvas.getBoundingClientRect();
        const styles = window.getComputedStyle(slide);
        const titleStyles = window.getComputedStyle(title);
        const targetOverlap =
          parseFloat(
            styles.getPropertyValue(
              '--editorial-title-overlap-desktop'
            )
          ) || 0;
        const inset =
          parseFloat(
            styles.getPropertyValue(
              '--editorial-inset-desktop'
            )
          ) || 0;

        if (
          compactMediaQuery.matches ||
          slide.classList.contains(
            'is-vertically-compact'
          )
        ) {
          const selectedTitleSize =
            parseFloat(
              styles.getPropertyValue(
                '--editorial-title-size-desktop'
              )
            ) || 1;
          const renderedTitleSize =
            parseFloat(titleStyles.fontSize) ||
            selectedTitleSize;
          const spacingScale = Math.min(
            1,
            renderedTitleSize / selectedTitleSize
          );
          const spaceAbove =
            parseFloat(
              styles.getPropertyValue(
                '--editorial-space-above-main'
              )
            ) || 0;
          const spaceBelow =
            parseFloat(
              styles.getPropertyValue(
                '--editorial-space-below-main'
              )
            ) || 0;

          slide.style.setProperty(
            '--editorial-space-above-main-responsive',
            `${spaceAbove * spacingScale}px`
          );
          slide.style.setProperty(
            '--editorial-space-below-main-responsive',
            `${spaceBelow * spacingScale}px`
          );
        } else {
          slide.style.removeProperty(
            '--editorial-space-above-main-responsive'
          );
          slide.style.removeProperty(
            '--editorial-space-below-main-responsive'
          );
        }

        const desiredLeft =
          titleRect.right -
          canvasRect.left -
          targetOverlap;
        const minimumMediaWidth = Math.max(
          360,
          canvasRect.width * 0.36
        );
        const maximumLeft =
          canvasRect.width -
          inset -
          minimumMediaWidth;
        const resolvedLeft = Math.max(
          inset,
          Math.min(
            maximumLeft,
            desiredLeft
          )
        );

        const copy = slide.querySelector(
          '.custom-carousel-glass__editorial-copy'
        );
        const copyRect = copy
          ? copy.getBoundingClientRect()
          : null;

        if (copy && copyRect) {
          const copyStyles =
            window.getComputedStyle(copy);
          const contentInset =
            parseFloat(copyStyles.paddingLeft) || 0;
          const contentLeft =
            copyRect.left -
            canvasRect.left +
            contentInset;
          const safeCopyWidth = Math.max(
            120,
            resolvedLeft -
              contentInset -
              contentLeft
          );

          slide.style.setProperty(
            '--editorial-safe-copy-width',
            `${Math.floor(safeCopyWidth)}px`
          );
        }

        slide.style.setProperty(
          '--editorial-media-left',
          `${Math.round(resolvedLeft)}px`
        );
      });
    }

    function updateHotspotImages() {
      images.forEach(function (image) {
        const hasOpenHotspot = Boolean(
          image.querySelector(
            '.custom-carousel-glass__hotspot.is-open'
          )
        );

        image.classList.toggle(
          'has-open-hotspot',
          hasOpenHotspot
        );
      });
    }

    function resetHotspotPosition(hotspot) {
      hotspot.classList.remove(
        'is-above',
        'is-left',
        'is-right',
        'is-closing'
      );
    }

    function closeHotspots(exceptHotspot) {
      hotspots.forEach(function (hotspot) {
        if (
          hotspot !== exceptHotspot &&
          hotspot.classList.contains('is-open')
        ) {
          hotspot.classList.add('is-closing');
          hotspot.classList.remove('is-open');

          window.setTimeout(function () {
            resetHotspotPosition(hotspot);
            updateHotspotImages();
          }, 230);
        } else if (hotspot !== exceptHotspot) {
          resetHotspotPosition(hotspot);
        }
      });

      updateHotspotImages();
    }

    function hasActiveHotspot() {
      return hotspots.some(function (hotspot) {
        return (
          hotspot.classList.contains('is-open') ||
          hotspot.classList.contains('is-closing')
        );
      });
    }

    function resumeAutoplayAfterInteraction() {
      startAutoplay();
    }

    function positionHotspotCard(hotspot) {
      const card = hotspot.querySelector(
        '.custom-carousel-glass__hotspot-card'
      );
      const image = hotspot.closest(
        '.custom-carousel-glass__image'
      );
      const slide = hotspot.closest(
        '.custom-carousel-glass__slide'
      );
      const textPanel = slide
        ? slide.querySelector(
            '.custom-carousel-glass__text'
          )
        : null;

      if (!card || !image) return;

      hotspot.classList.remove(
        'is-above',
        'is-left',
        'is-right'
      );

      if (mobileMediaQuery.matches) return;

      window.requestAnimationFrame(function () {
        const imageRect = image.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const hotspotRect = hotspot.getBoundingClientRect();
        const padding = 14;

        const hotspotYWithinImage =
          hotspotRect.top - imageRect.top;

        const hotspotIsLow =
          hotspotYWithinImage > imageRect.height * 0.58;

        if (
          hotspotIsLow ||
          cardRect.bottom > imageRect.bottom - padding ||
          cardRect.bottom > window.innerHeight - padding
        ) {
          hotspot.classList.add('is-above');
        }

        window.requestAnimationFrame(function () {
          const updatedRect = card.getBoundingClientRect();
          const textPanelRect = textPanel
            ? textPanel.getBoundingClientRect()
            : null;
          const leftBoundary =
            Math.max(imageRect.left, 0) + padding;
          const rightBoundary =
            Math.min(
              imageRect.right,
              window.innerWidth
            ) - padding;

          const overlapsTextPanel =
            textPanelRect &&
            updatedRect.left <
              textPanelRect.right + padding &&
            updatedRect.right >
              textPanelRect.left - padding &&
            updatedRect.top <
              textPanelRect.bottom + padding &&
            updatedRect.bottom >
              textPanelRect.top - padding;

          if (overlapsTextPanel) {
            hotspot.classList.remove('is-left');
            hotspot.classList.add('is-right');
          } else if (
            updatedRect.right >
            rightBoundary
          ) {
            hotspot.classList.remove('is-right');
            hotspot.classList.add('is-left');
          } else if (
            updatedRect.left < leftBoundary
          ) {
            hotspot.classList.remove('is-left');
            hotspot.classList.add('is-right');
          }
        });
      });
    }

    function closeCurrentHotspot(hotspot) {
      hotspot.classList.add('is-closing');
      hotspot.classList.remove('is-open');

      window.setTimeout(function () {
        resetHotspotPosition(hotspot);
        updateHotspotImages();
      }, 230);

      updateHotspotImages();
    }

    function restartNavProgress(button) {
      if (!button) return;

      button.classList.remove('active');
      button.offsetHeight;
      button.classList.add('active');
    }

    function goToSlide(index) {
      const clamped =
        ((index % slides.length) + slides.length) %
        slides.length;

      loadSlideMedia(slides[clamped], 'high');
      closeHotspots();

      track.style.transition = SLIDE_TRANSITION;
      track.style.transform =
        `translate3d(-${clamped * 100}%, 0, 0)`;

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle(
          'is-active',
          slideIndex === clamped
        );
      });

      navButtons.forEach(function (button, buttonIndex) {
        const isActive =
          buttonIndex === clamped;

        button.classList.toggle('active', isActive);
        button.classList.toggle(
          'is-complete',
          buttonIndex < clamped
        );

        if (isActive) {
          button.setAttribute(
            'aria-current',
            'true'
          );
        } else {
          button.removeAttribute('aria-current');
        }

        if (isActive) {
          restartNavProgress(button);
        }
      });

      currentIndex = clamped;
      scheduleNextSlideMedia(clamped);
    }

    function stopAutoplay() {
      root.classList.add('is-autoplay-paused');

      if (!intervalId) return;

      window.clearInterval(intervalId);
      intervalId = null;
    }

    function startAutoplay() {
      stopAutoplay();

      if (
        slides.length < 2 ||
        isPointerHovering
      ) {
        return;
      }

      root.classList.remove('is-autoplay-paused');

      restartNavProgress(
        navButtons[currentIndex]
      );

      intervalId = window.setInterval(function () {
        goToSlide(currentIndex + 1);
      }, AUTOPLAY_MS);
    }

    function handleAutoplayMouseEnter() {
      if (!hoverMediaQuery.matches) return;

      isPointerHovering = true;
      stopAutoplay();
    }

    function handleAutoplayMouseLeave() {
      if (!hoverMediaQuery.matches) return;

      isPointerHovering = false;
      startAutoplay();
    }

    function getClientX(event) {
      if (event.touches && event.touches.length) {
        return event.touches[0].clientX;
      }

      if (
        event.changedTouches &&
        event.changedTouches.length
      ) {
        return event.changedTouches[0].clientX;
      }

      return typeof event.clientX === 'number'
        ? event.clientX
        : currentX;
    }

    function applyDragResistance(distance) {
      const viewportWidth = Math.max(
        viewport.offsetWidth,
        1
      );

      const dragRatio = Math.min(
        Math.abs(distance) / viewportWidth,
        1
      );

      const resistance =
        1 - dragRatio * 0.2;

      return distance * resistance;
    }

    function startDrag(event) {
      if (
        event.target.closest(
          '.custom-carousel-glass__hotspot'
        )
      ) {
        return;
      }

      if (slides.length < 2) return;

      if (suppressClickTimeoutId) {
        window.clearTimeout(suppressClickTimeoutId);
        suppressClickTimeoutId = null;
      }

      dismissedHotspotOnDragStart =
        hasActiveHotspot();

      loadSlideMedia(
        slides[
          (currentIndex + 1) % slides.length
        ],
        'high'
      );
      loadSlideMedia(
        slides[
          (currentIndex - 1 + slides.length) %
            slides.length
        ],
        'high'
      );

      isDragging = true;
      suppressClick =
        dismissedHotspotOnDragStart;
      startX = getClientX(event);
      currentX = startX;
      startTime = performance.now();

      closeHotspots();

      viewport.classList.add('is-dragging');
      track.style.transition = 'none';
      stopAutoplay();
    }

    function moveDrag(event) {
      if (!isDragging) return;

      currentX = getClientX(event);

      const rawDistance = currentX - startX;
      const resistedDistance =
        applyDragResistance(rawDistance);

      if (
        Math.abs(rawDistance) >
        CLICK_SUPPRESS_THRESHOLD
      ) {
        suppressClick = true;
      }

      const percentage =
        (resistedDistance / viewport.offsetWidth) * 100;

      track.style.transform =
        `translate3d(calc(-${currentIndex * 100}% + ${percentage}%), 0, 0)`;
    }

    function endDrag(event) {
      if (!isDragging) return;

      currentX = getClientX(event || {});

      const distance = currentX - startX;
      const elapsed = Math.max(
        performance.now() - startTime,
        1
      );
      const signedVelocity = distance / elapsed;
      const absoluteVelocity = Math.abs(signedVelocity);

      const projectedDistance =
        distance +
        signedVelocity * MOMENTUM_MULTIPLIER;

      viewport.classList.remove('is-dragging');
      isDragging = false;

      if (
        Math.abs(projectedDistance) > DRAG_THRESHOLD ||
        absoluteVelocity > VELOCITY_THRESHOLD
      ) {
        goToSlide(
          projectedDistance < 0
            ? currentIndex + 1
            : currentIndex - 1
        );
      } else {
        goToSlide(currentIndex);
      }

      if (dismissedHotspotOnDragStart) {
        resumeAutoplayAfterInteraction();
      } else {
        startAutoplay();
      }

      if (
        Math.abs(distance) >
          CLICK_SUPPRESS_THRESHOLD ||
        dismissedHotspotOnDragStart
      ) {
        suppressClick = true;

        suppressClickTimeoutId =
          window.setTimeout(function () {
            suppressClick = false;
            dismissedHotspotOnDragStart = false;
            suppressClickTimeoutId = null;
          }, dismissedHotspotOnDragStart ? 400 : 140);
      } else {
        dismissedHotspotOnDragStart = false;
      }
    }

    function handleResize() {
      syncMobileTextHeights();
      syncEditorialMediaOverlap();
      syncEditorialVerticalFit();
      syncEditorialMediaOverlap();

      hotspots.forEach(function (hotspot) {
        if (hotspot.classList.contains('is-open')) {
          positionHotspotCard(hotspot);
        }
      });
    }

    slides.forEach(function (slide) {
      slide.addEventListener('click', function (event) {
        if (
          event.target.closest(
            '.custom-carousel-glass__hotspot'
          ) ||
          event.target.closest(
            '.custom-carousel-glass__button'
          ) ||
          event.target.closest(
            '.custom-carousel-glass__brand-logo-link[href]'
          )
        ) {
          return;
        }

        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (hasActiveHotspot()) {
          event.preventDefault();
          event.stopPropagation();
          closeHotspots();
          resumeAutoplayAfterInteraction();
          return;
        }

        const slideLink = slide.dataset.slideLink;

        if (slideLink) {
          window.location.href = slideLink;
        }
      });

      slide.addEventListener(
        'dragstart',
        function (event) {
          event.preventDefault();
        }
      );
    });

    hotspots.forEach(function (hotspot) {
      const toggle = hotspot.querySelector(
        '.custom-carousel-glass__hotspot-toggle'
      );

      hotspot.addEventListener(
        'mousedown',
        function (event) {
          event.stopPropagation();
        }
      );

      hotspot.addEventListener(
        'touchstart',
        function (event) {
          event.stopPropagation();
        },
        { passive: true }
      );

      if (!toggle) return;

      toggle.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (suppressClick) return;

          const shouldOpen =
            !hotspot.classList.contains('is-open');

          closeHotspots(hotspot);

          if (shouldOpen) {
            positionHotspotCard(hotspot);

            window.requestAnimationFrame(function () {
              hotspot.classList.remove('is-closing');
              hotspot.classList.add('is-open');
              updateHotspotImages();
            });

            stopAutoplay();
          } else {
            closeCurrentHotspot(hotspot);
            resumeAutoplayAfterInteraction();
          }
        }
      );
    });

    root.addEventListener('click', function (event) {
      if (
        !event.target.closest(
          '.custom-carousel-glass__hotspot'
        )
      ) {
        const hadActiveHotspot =
          hasActiveHotspot();

        closeHotspots();

        if (hadActiveHotspot) {
          resumeAutoplayAfterInteraction();
        }
      }
    });

    navButtons.forEach(function (button, index) {
      button.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();

          goToSlide(index);
          startAutoplay();
        }
      );
    });

    viewport.addEventListener(
      'mousedown',
      startDrag
    );
    viewport.addEventListener(
      'mousemove',
      moveDrag
    );
    viewport.addEventListener(
      'mouseup',
      endDrag
    );
    viewport.addEventListener(
      'mouseleave',
      endDrag
    );

    viewport.addEventListener(
      'touchstart',
      startDrag,
      { passive: true }
    );
    viewport.addEventListener(
      'touchmove',
      moveDrag,
      { passive: true }
    );
    viewport.addEventListener(
      'touchend',
      endDrag
    );
    viewport.addEventListener(
      'touchcancel',
      endDrag
    );

    window.addEventListener(
      'resize',
      handleResize
    );

    syncMobileTextHeights();
    syncEditorialMediaOverlap();
    syncEditorialVerticalFit();
    syncEditorialMediaOverlap();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncMobileTextHeights();
        syncEditorialMediaOverlap();
        syncEditorialVerticalFit();
        syncEditorialMediaOverlap();
      });
    }

    window.requestAnimationFrame(function () {
      syncMobileTextHeights();
      syncEditorialMediaOverlap();
      syncEditorialVerticalFit();
      syncEditorialMediaOverlap();
    });

    goToSlide(0);
    startAutoplay();

    root.addEventListener(
      'mouseenter',
      handleAutoplayMouseEnter
    );
    root.addEventListener(
      'mouseleave',
      handleAutoplayMouseLeave
    );

    root.dataset.carouselGlassInitialised = 'true';

    root._customCarouselGlassCleanup =
      function () {
        stopAutoplay();
        cancelDeferredMediaLoad();

        if (suppressClickTimeoutId) {
          window.clearTimeout(
            suppressClickTimeoutId
          );
        }

        window.removeEventListener(
          'resize',
          handleResize
        );

        root.removeEventListener(
          'mouseenter',
          handleAutoplayMouseEnter
        );
        root.removeEventListener(
          'mouseleave',
          handleAutoplayMouseLeave
        );
      };
  }

  function initAllGlassCarousels(scope) {
    const searchRoot = scope || document;

    searchRoot
      .querySelectorAll(
        '[data-custom-carousel-glass]'
      )
      .forEach(initGlassCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllGlassCarousels(document);
      }
    );
  } else {
    initAllGlassCarousels(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (event.target) {
        initAllGlassCarousels(event.target);
      }
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      const scope = event.target;

      if (!scope) return;

      scope
        .querySelectorAll(
          '[data-custom-carousel-glass]'
        )
        .forEach(function (root) {
          if (root._customCarouselGlassCleanup) {
            root._customCarouselGlassCleanup();
          }
        });
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const AUTOPLAY_MS = 7000;
  const DRAG_THRESHOLD = 50;
  const VELOCITY_THRESHOLD = 0.45;
  const CLICK_SUPPRESS_THRESHOLD = 8;
  const MOBILE_QUERY = '(max-width: 768px)';

  function initCarousel(root) {
    if (!root || root.dataset.carouselInitialised === 'true') return;

    const viewport = root.querySelector('.custom-carousel__viewport');
    const track = root.querySelector('.custom-carousel');
    const slides = Array.from(root.querySelectorAll('.custom-carousel__slide'));
    const navButtons = Array.from(root.querySelectorAll('.custom-carousel__nav button'));
    const hotspots = Array.from(root.querySelectorAll('.custom-carousel__hotspot'));
    const images = Array.from(root.querySelectorAll('.custom-carousel__image'));
    const mobileMediaQuery = window.matchMedia(MOBILE_QUERY);

    if (!viewport || !track || slides.length === 0 || navButtons.length === 0) return;

    let currentIndex = 0;
    let intervalId = null;
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    let startTime = 0;
    let suppressClick = false;

    function syncMobileTextHeights() {
      root.style.removeProperty('--custom-carousel-mobile-text-height');

      if (!mobileMediaQuery.matches) return;

      let maxTextHeight = 0;

      slides.forEach(function (slide) {
        const text = slide.querySelector('.custom-carousel__text');

        if (text) {
          maxTextHeight = Math.max(maxTextHeight, text.scrollHeight);
        }
      });

      if (maxTextHeight > 0) {
        root.style.setProperty('--custom-carousel-mobile-text-height', `${Math.ceil(maxTextHeight)}px`);
      }
    }

    function updateHotspotImages() {
      images.forEach(function (image) {
        const hasOpenHotspot = !!image.querySelector('.custom-carousel__hotspot.is-open');
        image.classList.toggle('has-open-hotspot', hasOpenHotspot);
      });
    }

    function closeHotspots(exceptHotspot) {
      hotspots.forEach(function (hotspot) {
        if (hotspot !== exceptHotspot && hotspot.classList.contains('is-open')) {
          hotspot.classList.add('is-closing');
          hotspot.classList.remove('is-open');

          window.setTimeout(function () {
            hotspot.classList.remove('is-above', 'is-left', 'is-right', 'is-closing');
            updateHotspotImages();
          }, 30);
        } else if (hotspot !== exceptHotspot) {
          hotspot.classList.remove('is-above', 'is-left', 'is-right', 'is-closing');
        }
      });

      updateHotspotImages();
    }

    function positionHotspotCard(hotspot) {
      const card = hotspot.querySelector('.custom-carousel__hotspot-card');
      const image = hotspot.closest('.custom-carousel__image');
      if (!card || !image) return;

      hotspot.classList.remove('is-above', 'is-left', 'is-right');

      if (mobileMediaQuery.matches) return;

      window.requestAnimationFrame(function () {
        const imageRect = image.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const hotspotRect = hotspot.getBoundingClientRect();
        const padding = 14;

        const hotspotYWithinImage = hotspotRect.top - imageRect.top;
        const hotspotIsLow = hotspotYWithinImage > imageRect.height * 0.58;

        if (hotspotIsLow || cardRect.bottom > imageRect.bottom - padding || cardRect.bottom > window.innerHeight - padding) {
          hotspot.classList.add('is-above');
        }

        window.requestAnimationFrame(function () {
          const updatedRect = card.getBoundingClientRect();

          if (updatedRect.right > window.innerWidth - padding) {
            hotspot.classList.add('is-left');
          }

          if (updatedRect.left < padding) {
            hotspot.classList.add('is-right');
          }
        });
      });
    }

    function closeCurrentHotspot(hotspot) {
      hotspot.classList.add('is-closing');
      hotspot.classList.remove('is-open');

      window.setTimeout(function () {
        hotspot.classList.remove('is-above', 'is-left', 'is-right', 'is-closing');
        updateHotspotImages();
      }, 30);

      updateHotspotImages();
    }

    function restartNavProgress(button) {
      const progressTrack = button ? button.querySelector('.custom-carousel__nav-track') : null;
      if (!progressTrack) return;

      progressTrack.style.animation = 'none';
      progressTrack.offsetHeight;
      progressTrack.style.animation = '';
    }

    function goToSlide(index) {
      const clamped = ((index % slides.length) + slides.length) % slides.length;

      closeHotspots();

      track.style.transition = 'transform 0.5s ease';
      track.style.transform = `translateX(-${clamped * 100}%)`;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === clamped);
      });

      navButtons.forEach(function (btn, i) {
        btn.classList.toggle('active', i === clamped);

        if (i === clamped) {
          restartNavProgress(btn);
        }
      });

      currentIndex = clamped;
    }

    function stopAutoplay() {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();

      if (slides.length < 2) return;

      intervalId = window.setInterval(function () {
        goToSlide(currentIndex + 1);
      }, AUTOPLAY_MS);
    }

    function getClientX(event) {
      if (event.touches && event.touches.length) return event.touches[0].clientX;
      if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientX;
      return event.clientX || currentX;
    }

    function startDrag(event) {
      if (event.target.closest('.custom-carousel__hotspot')) return;
      if (slides.length < 2) return;

      isDragging = true;
      suppressClick = false;
      startX = getClientX(event);
      currentX = startX;
      startTime = Date.now();

      closeHotspots();

      viewport.classList.add('is-dragging');
      track.style.transition = 'none';
      stopAutoplay();
    }

    function moveDrag(event) {
      if (!isDragging) return;

      currentX = getClientX(event);
      const diff = currentX - startX;

      if (Math.abs(diff) > CLICK_SUPPRESS_THRESHOLD) {
        suppressClick = true;
      }

      const percentage = (diff / viewport.offsetWidth) * 100;
      track.style.transform = `translateX(calc(-${currentIndex * 100}% + ${percentage}%))`;
    }

    function endDrag(event) {
      if (!isDragging) return;

      currentX = getClientX(event || {});
      const diff = currentX - startX;
      const elapsed = Math.max(Date.now() - startTime, 1);
      const velocity = Math.abs(diff) / elapsed;

      viewport.classList.remove('is-dragging');
      isDragging = false;

      if (Math.abs(diff) > DRAG_THRESHOLD || velocity > VELOCITY_THRESHOLD) {
        goToSlide(diff < 0 ? currentIndex + 1 : currentIndex - 1);
      } else {
        goToSlide(currentIndex);
      }

      startAutoplay();

      if (Math.abs(diff) > CLICK_SUPPRESS_THRESHOLD) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 120);
      }
    }

    function handleResize() {
      syncMobileTextHeights();

      hotspots.forEach(function (hotspot) {
        if (hotspot.classList.contains('is-open')) {
          positionHotspotCard(hotspot);
        }
      });
    }

    slides.forEach(function (slide) {
      slide.addEventListener('click', function (event) {
        if (event.target.closest('.custom-carousel__hotspot') || event.target.closest('.custom-carousel__button')) {
          return;
        }

        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const slideLink = slide.dataset.slideLink;
        if (slideLink) {
          window.location.href = slideLink;
        }
      });

      slide.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
    });

    hotspots.forEach(function (hotspot) {
      const toggle = hotspot.querySelector('.custom-carousel__hotspot-toggle');

      hotspot.addEventListener('mousedown', function (event) {
        event.stopPropagation();
      });

      hotspot.addEventListener('touchstart', function (event) {
        event.stopPropagation();
      }, { passive: true });

      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          if (suppressClick) return;

          const shouldOpen = !hotspot.classList.contains('is-open');

          closeHotspots(hotspot);

          if (shouldOpen) {
            positionHotspotCard(hotspot);

            window.requestAnimationFrame(function () {
              hotspot.classList.add('is-open');
              updateHotspotImages();
            });

            stopAutoplay();
          } else {
            closeCurrentHotspot(hotspot);
            startAutoplay();
          }
        });
      }
    });

    root.addEventListener('click', function (event) {
      if (!event.target.closest('.custom-carousel__hotspot')) {
        closeHotspots();
      }
    });

    navButtons.forEach(function (button, index) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goToSlide(index);
        startAutoplay();
      });
    });

    viewport.addEventListener('mousedown', startDrag);
    viewport.addEventListener('mousemove', moveDrag);
    viewport.addEventListener('mouseup', endDrag);
    viewport.addEventListener('mouseleave', endDrag);

    viewport.addEventListener('touchstart', startDrag, { passive: true });
    viewport.addEventListener('touchmove', moveDrag, { passive: true });
    viewport.addEventListener('touchend', endDrag);
    viewport.addEventListener('touchcancel', endDrag);

    window.addEventListener('resize', handleResize);

    syncMobileTextHeights();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncMobileTextHeights);
    }

    requestAnimationFrame(syncMobileTextHeights);

    goToSlide(0);
    startAutoplay();

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    root.dataset.carouselInitialised = 'true';
    root._customCarouselCleanup = function () {
      stopAutoplay();
      window.removeEventListener('resize', handleResize);
    };
  }

  function initAllCarousels(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-custom-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCarousels(document);
    });
  } else {
    initAllCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAllCarousels(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const scope = event.target;
    if (!scope) return;

    scope.querySelectorAll('[data-custom-carousel]').forEach(function (root) {
      if (root._customCarouselCleanup) root._customCarouselCleanup();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-immersive-series-viewer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initViewer(root) {
      if (!root || root.dataset.sdImmersiveInitialised === 'true') return;

      const stage = root.querySelector('[data-sd-immersive-stage]');
      const slides = Array.from(root.querySelectorAll('[data-sd-immersive-slide]'));
      const pagination = Array.from(root.querySelectorAll('[data-sd-immersive-pagination]'));
      const sceneTitles = Array.from(root.querySelectorAll('[data-sd-immersive-scene-title]'));
      const narratives = Array.from(root.querySelectorAll('[data-sd-immersive-narrative]'));
      const productPanels = Array.from(root.querySelectorAll('[data-sd-immersive-product-panel]'));
      const previousButton = root.querySelector('[data-sd-immersive-previous]');
      const nextButton = root.querySelector('[data-sd-immersive-next]');
      const expandButton = root.querySelector('[data-sd-immersive-expand]');
      const closeButton = root.querySelector('[data-sd-immersive-close]');
      const productsButton = root.querySelector('[data-sd-immersive-products-toggle]');
      const productsLabel = root.querySelector('[data-sd-immersive-products-label]');
      const productsClose = root.querySelector('[data-sd-immersive-products-close]');
      const fullscreenTools = root.querySelector('.sd-immersive__fullscreen-tools');

      if (!stage || !slides.length) return;

      root.dataset.sdImmersiveInitialised = 'true';
      root.style.setProperty('--sd-scene-count', slides.length);

      let currentIndex = 0;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerActive = false;
      let previousDocumentOverflow = '';
      let productRailFrame = 0;

      function updateProductRailFade(panel) {
        if (!panel || !panel.classList.contains('is-active')) {
          if (panel) panel.classList.remove('has-left-overflow', 'has-right-overflow');
          return;
        }

        const overflow = Math.max(0, panel.scrollWidth - panel.clientWidth);
        const scrollPosition = Math.max(0, panel.scrollLeft);
        const threshold = 3;

        panel.classList.toggle('has-left-overflow', overflow > threshold && scrollPosition > threshold);
        panel.classList.toggle('has-right-overflow', overflow > threshold && scrollPosition < overflow - threshold);
      }

      function scheduleProductRailFadeUpdate() {
        if (productRailFrame) window.cancelAnimationFrame(productRailFrame);
        productRailFrame = window.requestAnimationFrame(function () {
          productPanels.forEach(updateProductRailFade);
          productRailFrame = 0;
        });
      }

      function updateProductsButton() {
        const activePanel = productPanels[currentIndex];
        const count = activePanel
          ? activePanel.querySelectorAll('.sd-immersive__product-card').length
          : Number(slides[currentIndex].dataset.productCount || 0);

        root.classList.toggle('has-scene-products', count > 0);
        if (!productsButton) return;
        productsButton.hidden = count === 0;
        productsButton.setAttribute('aria-label', count === 1 ? 'View 1 product' : 'View ' + count + ' products');
        if (productsLabel) {
          productsLabel.textContent = count === 1 ? 'View 1 product' : 'View products (' + count + ')';
        }
      }

      function goTo(index) {
        currentIndex = (index + slides.length) % slides.length;
        root.classList.remove('is-products-open');
        if (productsButton) productsButton.setAttribute('aria-expanded', 'false');

        slides.forEach(function (slide, slideIndex) {
          const active = slideIndex === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        pagination.forEach(function (button, buttonIndex) {
          const active = buttonIndex === currentIndex;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });

        sceneTitles.forEach(function (title, titleIndex) {
          const active = titleIndex === currentIndex;
          title.classList.toggle('is-active', active);
          title.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        narratives.forEach(function (narrative, narrativeIndex) {
          const active = narrativeIndex === currentIndex;
          narrative.classList.toggle('is-active', active);
          narrative.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        productPanels.forEach(function (panel, panelIndex) {
          const active = panelIndex === currentIndex;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) panel.scrollLeft = 0;
        });

        updateProductsButton();
        scheduleProductRailFadeUpdate();
      }

      function setFullscreen(enabled) {
        root.classList.remove('is-products-open');
        root.classList.toggle('is-fullscreen', enabled);

        if (expandButton) expandButton.setAttribute('aria-expanded', enabled ? 'true' : 'false');
        if (fullscreenTools) fullscreenTools.setAttribute('aria-hidden', enabled ? 'false' : 'true');
        if (productsButton) productsButton.setAttribute('aria-expanded', 'false');

        if (enabled) {
          previousDocumentOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          if (closeButton) closeButton.focus({ preventScroll: true });
        } else {
          document.documentElement.style.overflow = previousDocumentOverflow;
          if (expandButton) expandButton.focus({ preventScroll: true });
        }

        scheduleProductRailFadeUpdate();
      }

      productPanels.forEach(function (panel) {
        panel.addEventListener('scroll', scheduleProductRailFadeUpdate, { passive: true });
      });

      if ('ResizeObserver' in window) {
        const productRailObserver = new ResizeObserver(scheduleProductRailFadeUpdate);
        productPanels.forEach(function (panel) { productRailObserver.observe(panel); });
      }

      if (previousButton) previousButton.addEventListener('click', function () { goTo(currentIndex - 1); });
      if (nextButton) nextButton.addEventListener('click', function () { goTo(currentIndex + 1); });

      pagination.forEach(function (button) {
        button.addEventListener('click', function () {
          goTo(Number(button.dataset.sdImmersivePagination));
        });
      });

      if (expandButton) expandButton.addEventListener('click', function () { setFullscreen(true); });
      if (closeButton) closeButton.addEventListener('click', function () { setFullscreen(false); });

      if (productsButton) {
        productsButton.addEventListener('click', function () {
          const open = root.classList.toggle('is-products-open');
          productsButton.setAttribute('aria-expanded', open ? 'true' : 'false');
          scheduleProductRailFadeUpdate();
        });
      }

      if (productsClose) {
        productsClose.addEventListener('click', function () {
          root.classList.remove('is-products-open');
          if (productsButton) productsButton.setAttribute('aria-expanded', 'false');
          if (productsButton) productsButton.focus({ preventScroll: true });
        });
      }

      stage.addEventListener('pointerdown', function (event) {
        if (event.target.closest('button, a')) return;
        pointerActive = true;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });

      stage.addEventListener('pointerup', function (event) {
        if (!pointerActive) return;
        pointerActive = false;
        const deltaX = event.clientX - pointerStartX;
        const deltaY = event.clientY - pointerStartY;

        if (Math.abs(deltaX) > 52 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          goTo(currentIndex + (deltaX < 0 ? 1 : -1));
        }
      });

      stage.addEventListener('pointercancel', function () { pointerActive = false; });

      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') goTo(currentIndex - 1);
        if (event.key === 'ArrowRight') goTo(currentIndex + 1);
        if (event.key === 'Escape') {
          if (root.classList.contains('is-products-open')) {
            root.classList.remove('is-products-open');
            if (productsButton) productsButton.setAttribute('aria-expanded', 'false');
          } else if (root.classList.contains('is-fullscreen')) {
            setFullscreen(false);
          }
        }
      });

      goTo(0);
    }

    function initAllViewers() {
      document.querySelectorAll('[data-sd-immersive]').forEach(initViewer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllViewers, { once: true });
    } else {
      initAllViewers();
    }

    document.addEventListener('shopify:section:load', function (event) {
      const root = event.target.querySelector('[data-sd-immersive]');
      if (root) initViewer(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      const root = event.target.querySelector('[data-sd-immersive]');
      if (root && root.classList.contains('is-fullscreen')) {
        document.documentElement.style.overflow = '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-promo-triptych-glass"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sectionSelector = '.custom-promo-triptych-glass';
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const cleanupBySection = new WeakMap();

  function hydrateImage(image) {
    if (!image || !image.dataset.triptychSrc) return;

    if (image.dataset.triptychSrcset) {
      image.srcset = image.dataset.triptychSrcset;
      image.removeAttribute('data-triptych-srcset');
    }

    image.src = image.dataset.triptychSrc;
    image.removeAttribute('data-triptych-src');
  }

  function initTriptych(section) {
    if (!section || cleanupBySection.has(section)) return;

    const grid = section.querySelector('.custom-promo-triptych-glass__grid');
    const deferredImages = Array.from(
      section.querySelectorAll('img[data-triptych-src]')
    );

    if (!grid || deferredImages.length === 0) return;

    let observer = null;

    function stopObserver() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    function startObserver() {
      stopObserver();

      if (!mobileQuery.matches) return;

      const remainingImages = deferredImages.filter(
        (image) => image.dataset.triptychSrc
      );

      if (remainingImages.length === 0) return;

      if (!('IntersectionObserver' in window)) {
        remainingImages.forEach(hydrateImage);
        return;
      }

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            hydrateImage(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          root: grid,
          rootMargin: '0px 60% 0px 60%',
          threshold: 0.01
        }
      );

      remainingImages.forEach((image) => observer.observe(image));
    }

    function handleViewportChange() {
      if (mobileQuery.matches) {
        startObserver();
      } else {
        stopObserver();
      }
    }

    handleViewportChange();

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', handleViewportChange);
    } else {
      mobileQuery.addListener(handleViewportChange);
    }

    cleanupBySection.set(section, function () {
      stopObserver();

      if (typeof mobileQuery.removeEventListener === 'function') {
        mobileQuery.removeEventListener('change', handleViewportChange);
      } else {
        mobileQuery.removeListener(handleViewportChange);
      }

      cleanupBySection.delete(section);
    });
  }

  function initAll(scope) {
    const root = scope || document;

    if (root.matches && root.matches(sectionSelector)) {
      initTriptych(root);
    }

    root.querySelectorAll(sectionSelector).forEach(initTriptych);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target.matches(sectionSelector)
      ? event.target
      : event.target.querySelector(sectionSelector);
    const cleanup = section && cleanupBySection.get(section);
    if (cleanup) cleanup();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
